import React from 'react';

import { Badge } from '@chakra-ui/react';

const METHOD_COLORS: Record<string, string> = {
  get: 'green',
  post: 'blue',
  put: 'orange',
  patch: 'orange',
  delete: 'red',
};

/** The HTTP method as a small colored label, e.g. GET in green. */
export const ApiMethodBadge = ({
  method,
  size = 'sm',
}: {
  method: string;
  size?: 'sm' | 'xs';
}) => (
  <Badge
    colorScheme={METHOD_COLORS[method] ?? 'gray'}
    variant="subtle"
    fontFamily="mono"
    fontSize={size === 'xs' ? '10px' : '12px'}
    px={size === 'xs' ? 1 : 2}
    py={size === 'xs' ? 0 : 0.5}
    borderRadius="md"
    minW={size === 'xs' ? '38px' : undefined}
    textAlign="center"
    flexShrink={0}
  >
    {method.toUpperCase()}
  </Badge>
);
